import { render, staticRenderFns } from "./theme-light-svg.vue?vue&type=template&id=4f3de22a&scoped=true"
import script from "./theme-light-svg.vue?vue&type=script&lang=js"
export * from "./theme-light-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3de22a",
  null
  
)

export default component.exports